import { RootStore } from './rootStore';
import { computed, action, makeObservable } from 'mobx';
import LocalStorage from './localStorage';
import { dateFormat, setDateFormat } from '../utils';

export interface AppSettings {
    dateFormat: string;
    showUrl?: boolean;
    showName?: boolean;
    showUniqueID?: boolean;
    showOrganizationType?: boolean;
}

const defaultSettings : AppSettings = {
    dateFormat: dateFormat,
    showUrl: true,
    showName: true,
    showUniqueID: false,
    showOrganizationType: false,
};

export default class AppSettingsStore {
    rootStore: RootStore;
    storage = new AppSettingsStorage();

    constructor(rootStore: RootStore) {
        this.rootStore = rootStore;
        this._appSettings = this.storage.value || defaultSettings;
        setDateFormat(this._appSettings.dateFormat);
        makeObservable(this, {
            //_appSettings: observable,
            appSettings: computed,
            setAppSettings: action,
        });
    }

    _appSettings: AppSettings;

    get appSettings(): AppSettings {
        return this._appSettings;
    }

    setAppSettings = (s: AppSettings) => {
        if (s ) {
            this._appSettings = {...s};
            setDateFormat(this._appSettings.dateFormat);
            this.storage.value = this._appSettings;
        }
    }
}

class AppSettingsStorage extends LocalStorage<AppSettings> {
    constructor() {
        super('appSettings', undefined, defaultSettings );
    }
}
